export enum AttackTypeEnum {
  GRASS = "GRASS",
  ROCK = "ROCK",
  FIRE = "FIRE",
  WATER = "WATER",
  ICE = "ICE",
  FLYING = "FLYING",
  ELECTRIC = "ELECTRIC",
  POISON = "POISON",
  PSYCHIC = "PSYCHIC",
  GROUND = "GROUND",
  DRAGON = "DRAGON",
  NORMAL = "NORMAL",
  GHOST = "GHOST",
  FIGHT = "FIGHT",
  BUG = "BUG",
}
